<template>
  <div id="edit-coupon">
    <form novalidate >
             <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
        {{'general._wait_'|translate}}
          <v-progress-linear
           indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-snackbar v-model="infoUpdatedSnack">
            <span>{{'coupons._cop_saved_succ_'|translate}}</span>
            <v-btn  @click="infoUpdatedSnack = false">{{'general._ok_'|translate}}</v-btn>
          </v-snackbar>
          <!-- coupon form -->

                <v-flex xs12 sm6>                  
            <v-select
              :items="merchants"
              v-model="form.merchant_id"
              :label="$t('coupons._sel_merchant_')"
              item-text="business_name"
              item-value="merchant_id"
              single-line
            ></v-select>
          </v-flex>
       

          <v-flex sm6 style="display:none">
            <v-text-field
             :label="$t('coupons._cop_id_')"
              type="text"
              autocomplete="given-name"
              v-model="coupon_id"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <h5>{{'coupons._cop_desc_'|translate}}</h5>

            <v-textarea
              :placeholder="$t('coupons._cop_desc_')"
              ref="projectDescription"
              v-model="form.description"
              :min-height="30"
              :max-height="350"
              required
              outline
            ></v-textarea>
          </v-flex>

                 <v-flex xs12>
         
           <v-text-field
              :label="$t('coupons._cop_phone_')"
              v-model="form.phone"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>

               <v-flex xs12>
          
             <v-text-field
              :label="$t('coupons._cop_store_name_')"
              v-model="form.store_name"
              autocomplete="given-name"
              required
            ></v-text-field>
              </v-flex>
     <v-flex xs12 sm6>
            <v-text-field
            type="number"
             :label="$t('coupons._cop_discount_')"
             
              v-model.number="form.discount"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>

        <v-flex xs12 sm6>
            <v-widget  :title="$t('coupons._cop_exp_date_')"  class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                >
                  <v-text-field
                    slot="activator"
                     :label="$t('coupons._cop_exp_date_')"
                   
                    v-model="form.expiration_date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.expiration_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
          </v-flex>

            <v-flex xs12 sm6>
              <!--  <p> Please Be sure to right well your address</p> -->
            <v-text-field
            :label="$t('coupons._cop_civic_')"
            
              type="text"
              autocomplete="name"
              
              v-model="form.civic"
            ></v-text-field>
          </v-flex>

        
          <v-flex xs12 sm6>
            <v-text-field
            :label="$t('coupons._cop_city_')"
              
              type="text"
              autocomplete="name"
              
              v-model="form.town"
            ></v-text-field>
          </v-flex>
            <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_region_')"
              type="text"
              autocomplete="name"
              
              v-model="form.region"
            ></v-text-field>
          </v-flex>
      
          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('coupons._cop_postalCode_')"
              type="text"
              autocomplete="name"
              v-model="form.postal_code"
            ></v-text-field>
          </v-flex>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          
        	<img :src="imageUrl" height="150" v-if="imageUrl"/>
          
					<v-text-field label="Select Image" @click='pickFile_image' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked_image"
           
					>

				</v-flex>

                        <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          
   <!--      	<img :src="imageUrl_bc" height="150" v-if="imageUrl_bc"/>
          
					<v-text-field label="Select Bar Code" @click='pickFile_image_bc' v-model='imageName_bc' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="image_bc"
						accept="image/*"
						@change="onFilePicked_image_bar_code"
           
					> -->
        <v-btn  color="primary" @click="create_qr_code" >{{'coupons._cop_Qr_code_'|translate}}</v-btn>
          <!-- 	<v-text-field label="write your Qr code text"  v-model="message"></v-text-field> -->
             <qr-code ref="qr_code" :text="message" @change="onFilePicked_image_bar_code" id="qr_code"></qr-code>
               <v-btn  v-if="message != ''" color="primary" @click="onFilePicked_image_bar_code" >{{'coupons._cop_save_Qr_code_'|translate}}</v-btn>
				</v-flex>
       <v-flex xs12>
            <v-layout row wrap>
              <v-card-actions style="display:inline">
                <v-btn @click="deleteCoupon" color="primary">{{'general._delete_'|translate}}</v-btn>
              </v-card-actions>

              <v-card-actions style="display:inline">
                <router-link :to="{ name: 'widget-coupons'}">
                  <v-btn color="primary">{{'general._back_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>

              <v-spacer></v-spacer>
              <v-card-actions style="display:inline">
                <v-btn type="submit" color="primary"  @click="updateCoupon" >{{'general._save_'|translate}}</v-btn>
              </v-card-actions>

             <!--    <v-card-actions style="display:inline" v-else-if="editMode==false">
                <v-btn type="submit" color="primary" @click="newCoupon" >Save</v-btn>
              </v-card-actions> -->
            </v-layout>
          </v-flex>

        </v-layout>
      </v-container>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import { storage } from '@/api/firebaseInit';
import vueSlider from "vue-slider-component";
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";
import Vue from 'vue';
const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "edit-coupon",
  components: {
    vueSlider
  },
    computed: {
    coupons(){
      let coupons =  this.$store.getters.coupons;
      return coupons;
    },
    
      merchants(){
      let merchants =  this.$store.getters.merchants;
      return merchants;
    } 
  },
      watch: {
   merchants(){
    
      let merchants =  this.$store.getters.merchants;
       this.loading=false
      return merchants;
    }
  },
  mounted() {  
 // this.projects =  this.$store.getters.projects;
   //  console.log(" projects "+JSON.stringify(this.projects))     
  },
  created() {
    //this.editMode = this.$route.params.editMode;
    //if(this.editMode == true){
    this.coupon_id = this.$route.params.coupon_id;
    //} 
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
  
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    }
  },
  data() {
    return {
       editMode:false,
       message:'',
      //projects:[],
       loading: false,
      Download_image_url:"",
      Download_bar_code_url:"",
      imageName : '',
			imageFile : '',
      imageUrl : '',
      imageName_bc : '',
			imageFile_bc : '',
			imageUrl_bc : '',
      old_images:[],
      members: [],
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      
      date: null,
      menu: false,
      modal: false,
      infoUpdatedSnack: false,
      backers: [],
      zones: quartiers,
      areas: communes,
      coupon_id: null,
      form: {

                id:'',
                barcode_url: '',
                created_by_id:firebase.auth().currentUser.uid,
                created_date:'',
                description:'', 
                discount:'',
                expiration_date:'', 
                merchant_id:'',
                image_url:'',
                store_name:'',
                phone:'',
                town:'',
                civic:'',
                region:'',
                postal_code:'',
                disclaimer:''
      }
    };
  },
   beforeRouteEnter(to, from, next) {
      var exp_date = ""
     console.log("here")
     // if(to.params.editMode == true || to.params.coupon_id =='xxxxxx'){
    db.collection("available_coupons")
      .doc(to.params.coupon_id)
      .get()
      .then(function(doc) {
          exp_date = new Date(doc.data().expiration_date.seconds*1000)
          exp_date = exp_date.getFullYear() + "-" + ("0" + (exp_date.getMonth() + 1)).slice(-2) + "-" +("0" + exp_date.getDate()).slice(-2)
        next(vm => {
                 
            //if(to.params.editMode == true || to.params.coupon_id =='xxxxxx'){
                 (vm.form.barcode_url= doc.data().barcode_url),
                 (vm.form.created_by_id=doc.data().created_by_id),
                 (vm.form.created_date=doc.data().created_date),
                 (vm.form.description=doc.data().description),
                 (vm.form.discount=doc.data().discount),
                
                 (vm.form.expiration_date = exp_date), 
                 (vm.form.merchant_id=doc.data().merchant_id),
                 (vm.form.image_url=doc.data().image_url),
                 (vm.form.store_name=doc.data().store_name),
                 (vm.form.phone=doc.data().phone),
                 (vm.form.town=doc.data().address.town),
                 (vm.form.postal_code=doc.data().address.postal_code),
                 (vm.form.region=doc.data().address.region),
                 (vm.form.civic=doc.data().address.civic),
                 (vm.form.disclaimer=doc.data().disclaimer);
           // }
        });
      });
    //  }
  }, 
  watch: {
    //if(this.editMode===true){
    $route: "fetchData"
   // }
  },
  methods: {

    newCoupon() {
       var latLng ={}   
       Vue.$geocoder.setDefaultMode('address');
           const that = this;
          var addressObj = {
          address_line_1: this.form.civic,
          address_line_2: '',
          city:           this.form.town,
          state:          this.form.region,               // province also valid
          zip_code:       this.form.postal_code,            // postal_code also valid
            }

        Vue.$geocoder.send(addressObj, response => { 
        latLng={lat:response.results[0].geometry.location.lat,long:response.results[0].geometry.location.lng}
  
        //console.log(JSON.stringify(latLng)) 
                  var address ={}
                  var data ={}
                  address.town= this.form.town
                  address.civic= this.form.civic
                  address.region= this.form.region
                  address.postal_code= this.form.postal_code
             
                 data.latLng= latLng;
                 data.description=this.form.description
                 data.discount=parseInt(this.form.discount)
                 data.expiration_date=new Date(this.form.expiration_date) 
                 data.merchant_id=this.form.merchant_id
                 data.store_name=this.form.store_name
                 data.phone=this.form.phone
                 data.address=address
                 data.created_by_id = this.created_by_id
                 data.created_date=new Date()

                  if(this.Download_image_url != "") {
                    data.image_url= this.Download_image_url
                  } 
                  if(this.Download_bar_code_url != "") {
                    data.barcode_url= this.Download_bar_code_url
                  }
                  
                const couponRef = db.collection("available_coupons").doc();
                const refKey = couponRef.id;
                this.coupon_id = refKey;
      
                 
                 data.id=this.coupon_id      
                 couponRef
                    .set(data)
                    .then(() => {
                      that.infoUpdatedSnack = true;
                      this.$store.dispatch('fetchCoupons')
                    })
                    .catch(error => {
                      console.error("Error adding coupon: ", error);
                    });
              });
    },
  pickFile_image (type) {
            this.$refs.image.click ()
        },
  pickFile_image_bc (type) {
            this.$refs.image_bc.click ()
        },

    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: "edit-coupon",
        params: {
          coupon_id: item.id
        }
      });
    },
    fetchData() {
    //  if(this.editMode == true || this.coupon_id =='xxxxxx'){
        console.log("here in fetch data")
      db.collection("available_coupons")
        .doc(this.coupon_id)
        .get()
        .then(function(doc) {
                (this.form.barcode_url= doc.data().barcode_url),
                 (this.form.created_by_id=doc.data().created_by_id),
                 (this.form.created_date=doc.data().created_date),
                 (this.form.description=doc.data().description),
                 (this.form.discount=doc.data().discount),
                 (this.form.expiration_date=new Date(doc.data().expiration_date).toISOString().substr(0, 10)), 
                 (this.form.merchant_id=doc.data().merchant_id),
                 (this.form.image_url=doc.data().image_url),
                 (this.form.store_name=doc.data().store_name),
                 (this.form.phone=doc.data().phone),
                   (this.form.town=doc.data().address.town),
                     (this.form.postal_code=doc.data().address.postal_code),
                       (this.form.region=doc.data().address.region),
                         (this.form.civic=doc.data().address.civic),
                 (this.form.disclaimer=doc.data().disclaimer);            
        });
    //  }
    },

    updateCoupon() {
        var that = this;
        var address ={}
        var data ={}
        var latLng ={}   
       
       Vue.$geocoder.setDefaultMode('address');
     
     var addressObj = {
    address_line_1: this.form.civic,
    address_line_2: '',
    city:           this.form.town,
    state:          this.form.region,               // province also valid
    zip_code:       this.form.postal_code,            // postal_code also valid
 
}

        Vue.$geocoder.send(addressObj, response => { 
             latLng={lat:response.results[0].geometry.location.lat,long:response.results[0].geometry.location.lng}
              console.log(JSON.stringify(latLng))
      address.town= this.form.town
      address.civic= this.form.civic
      address.region= this.form.region
      address.postal_code= this.form.postal_code
                
                 data.latLng= latLng;
                 data.description=this.form.description 
                 data.discount=parseInt(this.form.discount)
                 data.expiration_date=new Date(this.form.expiration_date) 
                 data.merchant_id=this.form.merchant_id
                 data.store_name=this.form.store_name
                 data.phone=this.form.phone
                 data.address=address
      if(this.Download_image_url != "") {
        data.image_url= this.Download_image_url
      } 
       if(this.Download_bar_code_url != "") {
         data.barcode_url= this.Download_bar_code_url
       }
      db.collection("available_coupons")
        .doc(this.coupon_id)
        .update(data)
        .then(() => {
          that.infoUpdatedSnack = true;
             this.$store.dispatch('fetchCoupons')
        })
        .catch(error => {
          console.error("Error adding coupon: ", error);
        });
       });
    },

    backtoRoute () {
       return '/widget-coupons';
    },
    deleteCoupon() {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("available_coupons")
          .doc(this.coupon_id)
          .delete()
          .then(function() {
            alert(`Cette Coupon a été suprimé`);
           
          });
           this.$store.dispatch('fetchCoupons')
            this.$router.push({name: 'widget-coupons'});
      }
    },
       saveImageUrl (url) {
           this.loading = false;
           this.Download_image_url=url;
            console.log("url",this.Download_image_url)
        },
       saveImageUrl_bar_code (url) {
           this.loading = false;
           this.Download_bar_code_url=url;
            console.log("url bar code",this.Download_bar_code_url)
        },
    onFilePicked_image (e) {
        var blob="";
       var that = this
      const files = e.target.files
     
			if(files[0] !== undefined) {
        this.loading = true;
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.imageFile = files[0] // this is an image file that can be sent to server...
        })
        
          blob = new Blob([files[0]], { type: files[0].type });
          //console.log("blob",blob)
       
     // Upload file and metadata to the object 'images/mountains.jpg'
var uploadTask = storage.ref().child(`media_attachements/${this.created_by_id}/medias/file-${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
  //  console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
       // console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
      //  console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
   that.saveImageUrl(downloadURL)
   
             downloadURL=''
             blob=''
             
  });
});

  

			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
    },
    

 b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
},

create_qr_code() {
 this.message ="";
  //var json = {'merchant_id':this.form.merchant_id,'id':this.coupon_id, 'expiration_date':""+this.form.expiration_date, 'discount':this.form.discount, 'created_date':""+new Date()}

 var json = {'id':this.coupon_id}
    //console.log(JSON.stringify(json))
  this.message =JSON.stringify(json)
  //console.log(JSON.stringify(this.message))
  //this.onFilePicked_image_bar_code()
},
onFilePicked_image_bar_code () {
  console.log("here in qr code")
        var blob="";
       var that = this
      
         var someimage = document.getElementById('qr_code');
         var myimg = someimage.getElementsByTagName('img')[0];
          var mysrc = myimg.src;
    
  var block = mysrc.split(";");
// Get the content type of the image
var contentType = block[0].split(":")[1];// In this case "image/gif"
// get the real base64 content of the file
var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
// Convert it to a blob to upload
var blob = this.b64toBlob(realData, contentType);
       
     // Upload file and metadata to the object 'images/mountains.jpg'
var uploadTask = storage.ref().child(`media_attachements/${this.created_by_id}/medias/file-${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
  //  console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
       // console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
      //  console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
 //   console.log('File available at bar code', downloadURL);
    that.saveImageUrl_bar_code(downloadURL)
          
             downloadURL=''
             blob=''
             
  });
});


		}

  }

};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/modifiers/EditCoupon.vue